export enum OrderDirection {
  Ascending = 1,
  Descending = 2,
}
